import { createApp } from 'vue'
import router from '../v2/colors/routes'
import ColorsApp from "../v2/colors/ColorsApp.vue";
import Popper from "vue3-popper";

document.addEventListener('DOMContentLoaded', () => {
    const app = createApp(ColorsApp)
    app.use(router)
    app.component("Popper", Popper)
    app.mount('#colors')
})